import axios from "axios";
import { store } from "../store/store";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("sts_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => {
    const newToken = response.headers["authorization"];
    if (newToken) {
      const token = newToken.split(" ")[1];
      if (token) {
        localStorage.setItem("sts_token", token);
      }
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch("logout");
      if (window.location.pathname === "/viewpicks") {
        window.location.href = "/packages/all";
      }
    }
    return Promise.reject(error);
  },
);

export default api;



// WEBPACK FOOTER //
// ./src/data/axios.js